var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-loading"},[(_vm.isWhite)?_c('div',{staticClass:"loader white-loader"}):_c('div',{staticClass:"loader black-loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }